import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SeoLink } from 'dibs-seo/exports/SeoLink';

import styles from './HpRespLocationsModuleItem.scss';

const locationsTitleMap = {
    USA: 'United States',
};
function HpRespLocationsModuleItem({ item, showLocation, showLocationLink, onClick }) {
    const { title, linkData } = item;
    const locationTitle = showLocation ? locationsTitleMap[title] || title : '';
    return (
        <div className={`${styles.item} colXs12 colLg3`}>
            <div className={styles.image}>
                <SeoLink
                    linkData={linkData}
                    className={styles.link}
                    style={{ backgroundImage: `url(${item.imageUrl})` }}
                    onClick={onClick}
                >
                    <span className={styles.box}>
                        <div className={styles.title}>
                            {locationTitle}
                            {showLocationLink && (
                                <div className={styles.shopLocation}>
                                    <FormattedMessage
                                        id="homepage.modules.locations.shop"
                                        defaultMessage="Shop"
                                    />
                                </div>
                            )}
                        </div>
                    </span>
                </SeoLink>
            </div>
        </div>
    );
}

HpRespLocationsModuleItem.defaultProps = {
    showLocation: false,
    onClick: () => {},
};

HpRespLocationsModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    showLocation: PropTypes.bool.isRequired,
    showLocationLink: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export { HpRespLocationsModuleItem };
